var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTbm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:red;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_tbm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,6.25A68.75,68.75,0,1,0,143.75,75,68.83,68.83,0,0,0,75,6.25Zm62.65,73.84a62.32,62.32,0,0,1-14.77,35.58l-1.07,1.27-4.54-4.54a3.44,3.44,0,1,0-4.86,4.88l4.53,4.53-1.27,1.07a62.32,62.32,0,0,1-35.58,14.77l-1.65.13v-6.44a3.44,3.44,0,0,0-6.88,0v6.44l-1.65-.13a62.32,62.32,0,0,1-35.58-14.77l-1.27-1.07,4.53-4.53a3.45,3.45,0,0,0,0-4.88,3.47,3.47,0,0,0-4.87,0l-4.53,4.54-1.07-1.27A62.29,62.29,0,0,1,12.35,80.09l-.14-1.65h6.45a3.44,3.44,0,1,0,0-6.88H12.21l.14-1.65A62.27,62.27,0,0,1,27.12,34.33l1.07-1.27,4.53,4.53a3.53,3.53,0,0,0,4.87,0,3.44,3.44,0,0,0,0-4.87l-4.53-4.53,1.26-1.08A62.43,62.43,0,0,1,69.91,12.35l1.65-.14v6.45a3.44,3.44,0,1,0,6.88,0V12.21l1.65.14a62.35,62.35,0,0,1,35.58,14.76l1.27,1.08-4.54,4.53a3.45,3.45,0,0,0,0,4.87,3.54,3.54,0,0,0,4.87,0l4.54-4.54,1.07,1.27a62.32,62.32,0,0,1,14.77,35.58l.13,1.65h-6.44a3.44,3.44,0,0,0,0,6.88h6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.41,55.59a3.4,3.4,0,0,0-2.43-1,3.44,3.44,0,0,0-2.44,1l-10,10-.91-.34a10.43,10.43,0,0,0-7.2,0l-.92.34L50.6,45.74a3.44,3.44,0,0,0-4.86,4.87L65.62,70.49l-.34.91a10.37,10.37,0,1,0,19.45,0l-.34-.92,10-10A3.42,3.42,0,0,0,94.41,55.59ZM75,79.48A4.48,4.48,0,1,1,79.48,75,4.49,4.49,0,0,1,75,79.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.41,55.59a3.4,3.4,0,0,0-2.43-1,3.44,3.44,0,0,0-2.44,1l-10,10-.91-.34a10.43,10.43,0,0,0-7.2,0l-.92.34L50.6,45.74a3.44,3.44,0,0,0-4.86,4.87L65.62,70.49l-.34.91a10.37,10.37,0,1,0,19.45,0l-.34-.92,10-10A3.42,3.42,0,0,0,94.41,55.59ZM75,79.48A4.48,4.48,0,1,1,79.48,75,4.49,4.49,0,0,1,75,79.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 150,
    height: 150
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTbm);
export default __webpack_public_path__ + "static/media/menu_tbm.ae2aefc8.svg";
export { ForwardRef as ReactComponent };